"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const Styles = {
    tab: (active, color, activeColor) => core_1.css `
      color: ${active ? activeColor : color} !important;
     `
};
exports.default = Styles;
